// extracted by mini-css-extract-plugin
export default {"melodyVideo":"uL-z","isFullWidth":"vL-z","landingPageVideo":"wL-z","play":"xL-z","iframeVideo":"yL-z","playHidden":"zL-z","fullwidth":"AL-z"};